import { useEffect, useState } from 'react';
import {
    PanelBody,
    Button,
    Modal,
    TextControl,
    SelectControl,
    TextareaControl,
    Spinner,
} from '@wordpress/components';
import { fetchData, saveData } from './api';
const CustomFieldTab = ({ openPopup, setActiveTab  }) => {
    const [isOpen, setIsOpen] = useState(false);
    const [fieldTitle, setFieldTitle] = useState('');
    const [gmptpkey, setGmptpkey] = useState('');
    const [isSaving, setIsSaving] = useState(false);
    const [fields, setFields] = useState([]); // Store existing fields
    const [editingFieldId, setEditingFieldId] = useState(null); // For editing
    const [loading, setLoading] = useState(true);
    const [isDeleting, setIsDeleting] = useState(false); // State for delete loading

    useEffect(() => {
        fetchFields(); // Fetch existing fields on mount
    }, []);

    const fetchFields = () => {
        fetchData(gmwcp_wp_ajax.getsettings, gmwcp_wp_ajax.nonce)
        .then((fetchedData) => {
            setFields(fetchedData.custom_fields);
            setLoading(false);
        })
        .catch((error) => {
            setLoading(false);
            console.error('Error fetching settings:', error);
        });
    };

    const openModal = (field = null) => {
        setIsOpen(true);
        if (field) {
            setEditingFieldId(field.id);
            setFieldTitle(field.title);
            setGmptpkey(field.gmptpkey);
        } else {
            resetForm(); // Reset for new field
        }
    };
    const closeModal = () => {
        setIsOpen(false);
        resetForm(); // Reset the form on close
    };

    const resetForm = () => {
        setFieldTitle('');
        setGmptpkey('');
        setEditingFieldId(null);
    };

    const saveField = () => {
        const data = {
            title: fieldTitle,
            gmptpkey: gmptpkey,
            id: editingFieldId, // Include ID if editing
        };
        setIsSaving(true);
        saveData(gmwcp_wp_ajax.savecustomfield, gmwcp_wp_ajax.nonce, data)
            .then((responseData) => {
                console.log(responseData);
                setIsSaving(false);
                if (responseData.success) {
                    fetchFields();
                    openPopup('Settings saved!');


                } else {
                    openPopup(responseData.message);
                }
            })
            .catch((error) => {
                setIsSaving(false);
                console.error('Error saving settings:', error);
                openPopup('Failed to save settings.');
            });
    };


   const deleteField = (fieldId) => {
        if (confirm('Are you sure you want to delete this field?')) {
            setIsDeleting(true); // Set deleting state to true
            const data = {
                id: fieldId, // Include ID if editing
            };
            saveData(gmwcp_wp_ajax.deletecustomfield, gmwcp_wp_ajax.nonce, data)
            .then((responseData) => {
                console.log(responseData);
                setIsSaving(false);
                if (responseData.success) {
                    fetchFields();
                    openPopup(responseData.message);
                } else {
                    openPopup(responseData.message);
                }
            })
            .catch((error) => {
                setIsSaving(false);
                console.error('Error saving settings:', error);
                openPopup('Failed to save settings.');
            }).finally(() => {
                setIsDeleting(false); // Reset deleting state
            });



        }
    };


    return (
        <PanelBody>
            <div>
                <Button isPrimary onClick={() => openModal()} className="mb-10">
                    Add Field
                </Button>
            </div>
            {loading ? ( // Conditional rendering based on loading state
                <Spinner />
            ) : (
                <>
                    <div className="cfcblist">
                        <table className="wp-list-table widefat fixed striped table-view-list">
                            <thead>
                                <tr>
                                    <th>Field Title</th>
                                    <th>Field Key</th>
                                    <th>Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                {fields.length > 0 ? ( // Check if fields exist
                                    fields.map((field) => (
                                        <tr key={field.id}>
                                            <td>{field.title}</td>
                                            <td>{field.gmptpkey}</td>
                                            <td>
                                                <Button isPrimary onClick={() => openModal(field)}>
                                                    Edit
                                                </Button>
                                                <Button
                                                    isDestructive
                                                    onClick={() => deleteField(field.id)}
                                                    disabled={isDeleting} // Disable button if deleting
                                                >
                                                    {isDeleting ? <Spinner size="small" /> : 'Delete'}
                                                </Button>
                                            </td>
                                        </tr>
                                    ))
                                ) : (
                                    <tr>
                                        <td colSpan="4" style={{ textAlign: 'center' }}>
                                            No fields available.
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>
                </>
            )}
            {isOpen && (
                <Modal
                    title='Product Meta Key Field'
                    onRequestClose={closeModal}
                >
                    <div>
                        <TextControl
                            label='Field Title'
                            value={fieldTitle}
                            onChange={(value) => setFieldTitle(value)}
                            placeholder='Enter Field Title'
                        />
                        <TextControl
                            label='Product Meta Key'
                            value={gmptpkey}
                            onChange={(value) => setGmptpkey(value)}
                            placeholder='Enter Field Key'
                        />
                    </div>
                    <div>
                        <Button isPrimary onClick={saveField} disabled={isSaving}>
                            {isSaving ? 'Saving...':'Save Field'}
                        </Button>
                        <Button isSecondary onClick={closeModal}>
                            Cancel
                        </Button>
                    </div>
                </Modal>
            )}
        </PanelBody>
    );
};

export default CustomFieldTab;
